import { GenericFieldValue } from '../data-objects'
import { FieldDefinition, FieldType, UIElement, UIElementDefinition, ValidationType } from '../definitions'

export interface FormNode {
  firstChild?: FormNode
  id: string
  level?: number
  nextSibling?: FormNode
  value: Control
}

export interface Control {
  data: GenericFieldValue
  fieldDefinition?: FieldDefinition
  formDefinition?: UIElementDefinition
  /**
   * the id of the main entity in the form
   */
  entityId?: string
  /**
   *
   */
  rowId?: string
  /**
   * the name of the main entity in the form
   */
  entityName: string
  /**
   * wether or not the field has been altered by a cta
   */
  isDirty: boolean
  state: 'Readonly' | 'Enabled'
  visibility: 'Visible' | 'Invisible'
  type: ControlType
  /**
   * Array of message ids of the message to apply to the node
   */
  validationMessages: string[]
  /**
   * array of parameters that will be used to format the validatio message
   */
  validationParams: string[]
  validationState: 'Valid' | 'Invalid' | 'Pending'
  /**
   * bitmask containing all validation types that can be affecting this control
   * if a flag i present it does not mean that at the moment that validation is active,
   * but that a validation of that type exists for this particular control
   */
  validationFlags: number
  /**
   * handles ranges, only for numeric fields
   */
  range?: FieldRange
  /**
   * handles dropdown options, only for Optionset fields
   */
  selectOptions?: FieldSelectOptions
  /**
   * What list is the field referring to
   * used to distinguish list fields
   */
  listName?: string
  rootFormModelName?: string
}

/**
 * The possible validation flags that a field can have, each of this
 * represents a validation type that can affect the field
 */
export enum ControlValidationType {
  Expression = 1 << 0,
  Mandatory = 1 << 1,
  Suggested = 1 << 2,
  Range = 1 << 3,
  Invisible = 1 << 4,
  Step = 1 << 5,
  Readonly = 1 << 6,
  RemoveOption = 1 << 7,
  KeepOption = 1 << 8,
}

/**
 * Mapping  between the validation types from the model and the respective flags for the field
 */
export const CONTROL_VALIDATION_MAPPER: Record<ValidationType, ControlValidationType> = {
  Expression: ControlValidationType.Expression,
  Mandatory: ControlValidationType.Mandatory,
  Suggested: ControlValidationType.Suggested,
  Range: ControlValidationType.Range,
  Invisible: ControlValidationType.Invisible,
  Step: ControlValidationType.Step,
  Readonly: ControlValidationType.Readonly,
  RemoveOption: ControlValidationType.RemoveOption,
  KeepOption: ControlValidationType.KeepOption,
}

export interface FieldRange {
  min: number
  max: number
}

export interface FieldSelectOptions {
  /**
   * array of dropdown option values to keep
   */
  keep: string[]
  /**
   * array of dropdown option values to remove
   */
  remove: string[]
}

export type ControlType = UIElement | FieldType
